export var getQuoteBasePrice = function (quote) {
    var calculationValue = quote.calculationValue, _a = quote.optionContentPremiumValue, optionContentPremiumValue = _a === void 0 ? 0 : _a, _b = quote.optionTheftPremiumValue, optionTheftPremiumValue = _b === void 0 ? 0 : _b, _c = quote.optionMotorVehiclesPremiumValue, optionMotorVehiclesPremiumValue = _c === void 0 ? 0 : _c, _d = quote.optionLegalAssistancePremiumValue, optionLegalAssistancePremiumValue = _d === void 0 ? 0 : _d;
    return (calculationValue -
        optionContentPremiumValue -
        optionTheftPremiumValue -
        optionMotorVehiclesPremiumValue -
        optionLegalAssistancePremiumValue);
};
